<div style="display: flex; height:100%; flex-direction: column">
  <div class="toolbar">
    <div class="toolbar-service">
      <a routerLink="/home"
        ><img alt="SeqCAT Logo" src="./assets/images/SeqCAT_Logo.svg"
      /></a>
      <span>SeqCAT</span>
    </div>
    <div class="toolbar-menu">
      <a class="toolbar-menu-item" routerLink="/home">Home</a>
      <a class="toolbar-menu-item" routerLink="/converter">Toolbox</a>
      <a class="toolbar-menu-item" routerLink="/api">API</a>
      <a class="toolbar-menu-item" routerLink="/help">Help</a>
    </div>
  </div>

  <div class="content">
    <router-outlet></router-outlet>
  </div>

  <footer class="toolbar" style="justify-content: center">
    <!-- <div style="height:40px;width: 120px; margin:10px auto"><a href="https://creativecommons.org/licenses/by-sa/4.0/deed.en" target="_blank" rel="noopener noreferrer"><img src="./assets/images/by-sa.svg"
          style="height:40px;width: 120px;"/></a></div>
          This website does not use cookies or store personal information. Content on this site is licensed under a <a href="https://creativecommons.org/licenses/by-sa/4.0/deed.en" target="_blank" rel="noopener noreferrer">Creative Commons Attribution-ShareAlike 4.0 International License (CC BY-SA 4.0)</a>. -->
    <div class="toolbar-menu">
      <a class="toolbar-menu-item" routerLink="/imprint">Imprint</a>
      <a class="toolbar-menu-item" routerLink="/impressum-data-privacy">Data Privacy</a>
      <a class="toolbar-menu-item" routerLink="/about">About</a>
    </div>
  </footer>
</div>
